import { ReactNode, useState } from 'react';
import { AppSidebar } from './AppSidebar';
import { SidebarCollapseToggle } from './SidebarCollapseToggle';
import { AppHeader } from './AppHeader';
import { AppContent } from './AppContent';
import { readSidebarCollapsedFromStorage, sidebarLayoutClasses } from './sidebar-layout';
import { cn } from '@/lib/utils';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: Readonly<MainLayoutProps>) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(readSidebarCollapsedFromStorage);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(prev => {
      const next = !prev;
      globalThis.localStorage?.setItem('ffshop-sidebar-collapsed', String(next));
      return next;
    });
  };

  const { spacer: spacerWidthClass } = sidebarLayoutClasses(isSidebarCollapsed);

  return (
    <div className="flex h-screen overflow-hidden bg-muted/10">
      <AppSidebar isCollapsed={isSidebarCollapsed} />
      <SidebarCollapseToggle isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
      {/* Reserves horizontal space — sidebar is fixed and out of flow */}
      <div
        className={cn('shrink-0 transition-all duration-300', spacerWidthClass)}
        aria-hidden
      />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <AppHeader />
        <div className="flex-1 overflow-auto bg-muted/10">
          <AppContent>{children}</AppContent>
        </div>
      </div>
    </div>
  );
}
